export default "__VITE_ASSET__DxTg4FiE__"